import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'reminders'] as const;

type ListParams = {
  subject_id?: string;
  provider_id?: string;
  is_completed?: boolean;
};

export const keys = {
  all,
  lists: () => [...all, 'lists'] as const,
  list: (params: ListParams) =>
    [
      ...keys.lists(),
      params.subject_id ?? null,
      params.provider_id ?? null,
      params.is_completed ?? null,
    ] as const,
  listCount: (params: ListParams) => [...keys.list(params), 'count'] as const,
  detail: (id: string) => [...all, 'detail', id] as const,
  upcomingAll: () => [...all, 'upcoming'] as const,
  upcoming: (spaceId: string) => [...keys.upcomingAll(), spaceId] as const,
};
